// Store
export interface Store {
    stepper?: {
        step?: Record<string, string>; // stepperId -> step name
    };
}
export const initialStore: Store = {};
